import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TopNavBar from '../../components/TopBarNav/TopBarNav';
import MainNav from '../../components/MainNav/MainNav';
import './Header.scss';

class Header extends PureComponent {
  static propTypes = {
    headerCallsActionCreators: PropTypes.any.isRequired,
    mainNavigationData: PropTypes.any,
    isMenuVisible: PropTypes.bool,
    loginStatus: PropTypes.bool,
    showGlobalHeader: PropTypes.bool,
    userInfo: PropTypes.object,
    loginLoader: PropTypes.bool,
    shortListData: PropTypes.object,
    cartData: PropTypes.object,
    redisCommonData: PropTypes.any,
    router: PropTypes.object,
    isCartCount: PropTypes.number,
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { mainNavigationData, isMenuVisible } = this.props;
    const navData = mainNavigationData && mainNavigationData.topBarNav;
    return (
      <header className="header container-fluid">
        <div className="header_top-panel" id="topNavBar">
          {navData && (
            <TopNavBar
              isMenuVisible={isMenuVisible}
              isSupported={this.props.isSupported}
              topNavData={navData}
              {...this.props}
            />
          )}
        </div>
        <MainNav {...this.props} />
      </header>
    );
  }
}

Header.defaultProps = {
  mainNavigationData: {},
  showGlobalHeader: true,
  isMenuVisible: true,
};

export default Header;
